// Groups a customer list into duplicate clusters by exact normalized-name or
// exact normalized-phone match. Hashmap-based (O(n)) rather than pairwise, so
// it stays fast against the full ~7k-row customer table, not just a handful
// of search results.

export const normName = (str) =>
  (str || '').toLowerCase().replace(/[^a-z0-9]/g, '').trim();

export const normPhone = (str) =>
  (str || '').replace(/\D/g, '').replace(/^1/, '');

export const customerFullName = (c) =>
  c.CustomerFullName || `${c.CustomerFirstName || ''} ${c.CustomerLastName || ''}`.trim();

export const buildDuplicateGroups = (list) => {
  const parent = list.map((_, i) => i);
  const find = (x) => (parent[x] === x ? x : (parent[x] = find(parent[x])));
  const union = (a, b) => {
    const ra = find(a), rb = find(b);
    if (ra !== rb) parent[ra] = rb;
  };
  const mergeBucket = (indices) => {
    for (let i = 1; i < indices.length; i++) union(indices[0], indices[i]);
  };

  const byName = new Map();
  const byPhone = new Map();
  list.forEach((c, idx) => {
    const nameKey = normName(customerFullName(c));
    const phoneKey = normPhone(c.CustomerPhone);
    if (nameKey) {
      if (!byName.has(nameKey)) byName.set(nameKey, []);
      byName.get(nameKey).push(idx);
    }
    if (phoneKey && phoneKey.length >= 7) {
      if (!byPhone.has(phoneKey)) byPhone.set(phoneKey, []);
      byPhone.get(phoneKey).push(idx);
    }
  });
  byName.forEach((indices) => { if (indices.length > 1) mergeBucket(indices); });
  byPhone.forEach((indices) => { if (indices.length > 1) mergeBucket(indices); });

  const groups = new Map();
  list.forEach((c, i) => {
    const root = find(i);
    if (!groups.has(root)) groups.set(root, []);
    groups.get(root).push(c);
  });

  return [...groups.values()]
    .filter((g) => g.length > 1)
    .sort((a, b) => customerFullName(a[0]).localeCompare(customerFullName(b[0])));
};
